import { useRoute } from 'wouter';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { Container } from '@/components/ui/container';
import { Skeleton } from '@/components/ui/skeleton';
// Using the features version (simpler, 7 tabs) as the source of truth
import { InstallationDetail } from '@/features/operations/components/installations/installation-detail';

export default function InstallationDetailPage() {
  const [match, params] = useRoute<{ id: string }>('/installations/:id');

  if (!match) {
    return null;
  }

  const installationId = parseInt(params.id);

  return (
    <>
      <Helmet>
        <title>Installation Details | DomElec Solar</title>
      </Helmet>
      <Container className="py-8 max-w-7xl mx-auto">
        <Suspense fallback={<Skeleton className="h-[600px] w-full" />}>
          <InstallationDetail id={installationId} />
        </Suspense>
      </Container>
    </>
  );
}
